import React from "react";
import { Star } from "lucide-react";

export function Stars({ value = 0, size = 16, className = "" }) {
  return (
    <div className={`flex items-center ${className}`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          style={{ width: size, height: size }}
          className={i <= Math.round(value) ? "fill-amber-400 text-amber-400" : "text-zinc-300"}
        />
      ))}
    </div>
  );
}

export function StarInput({ value, onChange }) {
  return (
    <div className="flex gap-1.5">
      {[1, 2, 3, 4, 5].map((i) => (
        <button key={i} type="button" data-testid={`review-star-${i}`} onClick={() => onChange(i)} className="transition-transform hover:scale-110">
          <Star className={`h-8 w-8 ${i <= value ? "fill-amber-400 text-amber-400" : "text-zinc-300"}`} />
        </button>
      ))}
    </div>
  );
}
